const Background = () => (
  <div
    className="fixed inset-0 z-0 overflow-hidden pointer-events-none"
    aria-hidden="true"
  >
    <div className="orb orb-1" />
    <div className="orb orb-2" />
    <div className="orb orb-3" />
  </div>
);

export default Background;
